"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterValues = void 0;
const react_1 = __importDefault(require("react"));
const Image_1 = require("../Image");
function FooterValues(_a) {
    var props = __rest(_a, []);
    return (react_1.default.createElement("div", Object.assign({ className: "hidden md:block pt-32 px-12 pb-16 border-b-1 border-gray-light" }, props),
        react_1.default.createElement("h2", { className: "text-center text-gray-d text-xl font-medium uppercase mb-20" }, "Guided by our values"),
        react_1.default.createElement("section", { className: "grid grid-cols-5 items-start" },
            react_1.default.createElement("div", { className: "flex flex-col justify-center items-center px-4" },
                react_1.default.createElement(Image_1.Image, { src: "/1-treasure-icon?fmt=png-alpha", alt: "Treasuring Biblical Truth Icon", loading: "lazy" }),
                react_1.default.createElement("p", { className: "mt-4 text-sm text-white text-center" }, "TREASURE BIBLICAL TRUTH")),
            react_1.default.createElement("div", { className: "flex flex-col justify-center items-center px-4" },
                react_1.default.createElement(Image_1.Image, { src: "/2-care-icon?fmt=png-alpha", alt: "Care About Character Icon", loading: "lazy" }),
                react_1.default.createElement("p", { className: "mt-4 text-sm text-white text-center" }, "CARE ABOUT CHARACTER")),
            react_1.default.createElement("div", { className: "flex flex-col justify-center items-center px-4" },
                react_1.default.createElement(Image_1.Image, { src: "/3-be-better-icon?fmt=png-alpha", alt: "Be Better Together Icon", loading: "lazy" }),
                react_1.default.createElement("p", { className: "mt-4 text-sm text-white text-center" }, "BE BETTER TOGETHER")),
            react_1.default.createElement("div", { className: "flex flex-col justify-center items-center px-4" },
                react_1.default.createElement(Image_1.Image, { src: "/4-create-icon?fmt=png-alpha", alt: "Create Customer Delight Icon", loading: "lazy" }),
                react_1.default.createElement("p", { className: "mt-4 text-sm text-white text-center" }, "CREATE CUSTOMER DELIGHT")),
            react_1.default.createElement("div", { className: "flex flex-col justify-center items-center px-4" },
                react_1.default.createElement(Image_1.Image, { src: "/5-chart-icon?fmt=png-alpha", alt: "Chart What's Next Icon", loading: "lazy" }),
                react_1.default.createElement("p", { className: "mt-4 text-sm text-white text-center" }, "CHART WHAT'S NEXT")))));
}
exports.FooterValues = FooterValues;
